// src/components/admin/members/details/training/member-training-tab.tsx
import React from "react";
import { MemberTableDatatypes } from "@/types/member";
import { SeriesTable } from "@/components/admin/training/series/series-table";

interface MemberTrainingTabProps {
  memberInfo: MemberTableDatatypes | undefined;
}

export const MemberTrainingTab: React.FC<MemberTrainingTabProps> = ({ memberInfo }) => {
  return (
    <div className="w-full">
      <SeriesTable memberId={memberInfo?.id} />
    </div>
  );
};

export default MemberTrainingTab;